import publicClient from "./public-client";
import { HOST_GROWME } from "../../helpers/constants";

export default class PublicPaymentAPI {
  static createPublicPaymentIntention({ companyName, rut, email, phone, catalogId, captchaToken }) {
    return publicClient.post(
      `${HOST_GROWME}/public/payments`,
      { companyName, rut, email, phone, catalogId, captchaToken },
      { headers: { "Content-Type": "application/json" } }
    );
  }
}
